import "./PenaltyRow.css";
import PenaltyButton from "./PenaltyButton";
import { MAX_PENALTIES } from "./common/Constants";

type PenaltyRowProps = {
  count: number;
  size: string;
  playable: boolean;
};

function PenaltyRow({ count, size, playable }: PenaltyRowProps) {
  const buttons: JSX.Element[] = [];

  for (let i = 0; i < MAX_PENALTIES; i++) {
    if (i < count) {
      buttons.push(
        <PenaltyButton key={i} marked={true} disabled={true} size={size} />,
      );
    } else if (i === count) {
      buttons.push(
        <PenaltyButton
          key={i}
          marked={false}
          disabled={playable ? false : true}
          size={size}
        />,
      );
    } else {
      buttons.push(
        <PenaltyButton key={i} marked={false} disabled={true} size={size} />,
      );
    }
  }

  return (
    <div className={`penaltyRow ${size}`}>
      Penalties
      {buttons}
    </div>
  );
}

export default PenaltyRow;
